module.exports = __webpack_public_path__ + "static/img/yanjing.333a7d20.png";